<template>
  <v-card
      class="mb-12  mx-4"
      elevation="0"
  >
    <v-row>
      <v-col cols="12">
        <v-btn
            width="250"
            color="secondary"
            class="textColor--text sm-font500-16 rounded-xl me-3"
            depressed
            height="48"
        >
          <div class="d-flex align-center justify-space-between w-100" @click="addPlanModal = true">
            <p class="mb-0">افزودن برنامه</p>
            <v-icon size="20">mdi-plus</v-icon>
          </div>
        </v-btn>
      </v-col>

      <template v-if="allSteps.length > 0">
        <v-col md="6" cols="12" v-for="(item, index) in allSteps" :key="index">
          <v-card depressed outlined class="rounded-lg d-flex px-4" height="48"
                  style="border-color: #8D9DC7">
            <div class="d-flex justify-space-between align-center w-100">
              <p class="mb-0 thirdColor--text sm-font500-12">{{ item.title }}</p>
              <div>
                <v-btn icon @click="openEditStep(item)">
                  <img src="@/assets/Icon/Table/edit-2.svg" alt="">
                </v-btn>
                <v-btn :loading="loadingDelete" icon @click="deleteStep(item)">
                  <img src="@/assets/Icon/Table/trash.svg" alt="">
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </template>
      <v-col cols="12" class="d-flex justify-end" style="margin-top: 100px">
        <v-btn
            color="positive"
            class="textColor--text sm-font500-16 rounded-xl me-3"
            depressed
            height="48"
            width="230"
            @click="nextStep"
        >
          ثبت و ادامه
        </v-btn>

        <v-btn width="230" height="48" depressed color="nagative"
               class="textColor--text sm-font500-16 rounded-xl" @click="cancelProcess">
          انصراف
        </v-btn>
      </v-col>


      <v-dialog v-model="addPlanModal" width="850">
        <v-card class="pa-10 rounded-xl">
          <div class="d-flex mb-7">
            <p class="mb-0 sm-font600-16 textColorSecond--text">ایجاد برنامه</p>
          </div>
          <v-row>
            <v-col cols="6">
              <label>عنوان برنامه</label>
              <v-text-field
                  v-model="dataModel.title"
                  class="rounded-lg pr-0 sm-font400-14"
                  solo
                  single-line height="48"
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label>ترتیب</label>
              <v-text-field v-model="dataModel.order" class="rounded-lg pr-0 sm-font400-14" solo
                            single-line height="48" hide-details></v-text-field>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                  color="positive"
                  class="textColor--text sm-font500-16 rounded-xl me-3"
                  depressed
                  height="48"
                  width="230"
                  :loading="loading"
                  @click="submit"
              >
                ثبت
              </v-btn>

              <v-btn width="230" height="48" depressed color="nagative"
                     class="textColor--text sm-font500-16 rounded-xl" @click="addPlanModal = false">
                انصراف
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>
<script>
import courseApi from '@/Services/modules/courses'
export default {
  name: "plans",
  data() {
    return {
      loadingDelete: false,

      editForm: false,
      addPlanModal: false,
      allSteps: [],
      dataModel: {}
    }
  },
  methods: {
    getData() {
      let data = {
        course: this.$route.params.id
      }
      courseApi.getLessons(data).then(res => {
        this.allSteps = res.data.results
      })
    },
    openEditStep(item) {
      this.dataModel = item
      this.addPlanModal = true
      this.editForm = true
    },
    deleteStep(item) {
      this.loadingDelete= true
      courseApi.deleteLessons(item.id).then(() => {
        this.getData()
        this.$toast.success('با موفقیت انجام شد!')
      }).finally(()=> {
        this.loadingDelete= true
      })
    },
    nextStep() {
      this.$emit("nextStep", 3)
    },
    cancelProcess() {
      this.$router.push('/courses/course-list')
    },
    submit() {
      this.loading= true
      if (this.editForm) {
        courseApi.editLessons(this.dataModel).then(() => {
          this.editForm = false
          this.addPlanModal = false
          this.dataModel = {}
          this.getData()
          this.$toast.success('با موفقیت انجام شد!')
        }).finally(()=> {
          this.loading= false
        })
      } else {
        let data = {
          ...this.dataModel,
          course: this.$route.params.id
        }
        courseApi.addLessons(data).then(() => {
          this.addPlanModal = false
          this.dataModel = {}
          this.getData()
          this.$toast.success('با موفقیت انجام شد!')
        }).finally(()=> {
          this.loading= false
        })
      }
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
<style scoped>

</style>
